<template>
    <div class="egg-container">
        <div class="swiper-container" ref="mySwiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide page-1">
                    <div class="slide-content">
                        <h1>第一屏</h1>
                        <p>竖屏滚动效果演示</p>
                    </div>
                </div>
                <div class="swiper-slide page-2">
                    <div class="slide-content">
                        <h1>第二屏</h1>
                        <p>继续向下滑动</p>
                    </div>
                </div>
                <div class="swiper-slide page-3">
                    <div class="slide-content">
                        <h1>第三屏</h1>
                        <p>这是最后一屏</p>
                    </div>
                </div>
            </div>
            <!-- 分页器 -->
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>
<script>

import Swiper from 'swiper';
// import 'swiper/css/swiper.css';

export default {
    name: 'Egg',
    data() {
        return {
            pass: '6Z2e5rSy5LmL5b+D',
            mySwiper: null,
        };
    },
    created() {
        // console.log('Egg 组件已创建');
        if (this.$route.params.id !== this.pass) {
            this.$router.push('/'); // 如果密码不正确，重定向到首页
        }
    },
    mounted() {
        this.initSwiper();
    },
    beforeDestroy() {
        if (this.mySwiper) {
            this.mySwiper.destroy();
        }
    },
    methods: {
        initSwiper() {
            this.mySwiper = new Swiper(this.$refs.mySwiper, {
                direction: 'vertical',
                slidesPerView: 1,
                spaceBetween: 0,
                loop: false,
                speed: 800,
                mousewheel: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '"></span>';
                    },
                },
                on: {
                    slideChange: function () {
                        console.log('当前滑动到第' + (this.activeIndex + 1) + '屏');
                    },
                }
            });
        },
    },
}
</script>

<style scoped>
.egg-container {
    width: 100%;
    height: var(--main-height);
    overflow: hidden;
}

.swiper-container {
    width: 100%;
    height: var(--main-height);
}

.swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 18px;
    background: #fff;
    color: #fff;
    position: relative;
}

.slide-content {
    max-width: 600px;
    padding: 20px;
}

.slide-content h1 {
    font-size: 48px;
    margin-bottom: 20px;
    font-weight: bold;
}

.slide-content p {
    font-size: 24px;
    opacity: 0.8;
}

.page-1 {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.page-2 {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.page-3 {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

/* 分页器样式 */
.swiper-pagination {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
}

.swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    background: rgba(255, 255, 255, 0.5);
    margin: 8px 0;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease;
}

.swiper-pagination-bullet-active {
    background: #fff;
    transform: scale(1.3);
}

/* 响应式设计 */
@media (max-width: 768px) {
    .slide-content h1 {
        font-size: 36px;
    }
    
    .slide-content p {
        font-size: 18px;
    }
}
</style>